import * as React from "react";

import backgroundColoursCss from "../../templates/utils/backgroundColoursCss";
import styled from "../../theme/styled";
import { HalfColumnWidthWrapper } from "../confines-wrappers";
import DynamicImage from "../dynamic-image";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphBoxOutImageHalfColumnWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
  backgroundColors?: string[];
}

const ParagraphBoxOutImageHalfColumnWidthWrapper = styled<
  IParagraphBoxOutImageHalfColumnWidthWrapper,
  "div"
>("div")`
  .content-container {
    ${props => backgroundColoursCss(props.backgroundColors)};

    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphBoxOutImageHalfColumnWidth = ({ type, content }: IProps) => {
  const imgRel = content.relationships;
  const image = imgRel && imgRel.field_image;
  const backgroundColors = content.field_background_colour_s_;

  if (!image) {
    return null;
  }

  return (
    <ParagraphBoxOutImageHalfColumnWidthWrapper
      className="paragraph-box-out-image-half-column-width"
      type={type}
      backgroundColors={backgroundColors}
    >
      <div className="content-container">
        <HalfColumnWidthWrapper className="content-wrapper">
          <DynamicImage
            data={image}
            alt={content.field_image.alt}
          />
        </HalfColumnWidthWrapper>
      </div>
    </ParagraphBoxOutImageHalfColumnWidthWrapper>
  );
};

export default ParagraphBoxOutImageHalfColumnWidth;
